import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../config/api';

const AuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setToken, setUser } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');
    const error = searchParams.get('error');

    if (error) {
      console.error('OAuth error:', error);
      navigate('/login?error=oauth_failed');
      return;
    }

    if (token) {
      // Set token in localStorage first
      localStorage.setItem('token', token);

      // Set token in axios instance for the API call
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

      // Fetch user data using the api instance
      api
        .get('/auth/me')
        .then((response) => {
          const userData = response.data.user;

          if (userData) {
            // Map snake_case to camelCase to match the User interface
            const user = {
              id: userData.id,
              email: userData.email,
              fullName: userData.full_name,
              avatarUrl: userData.avatar_url,
              isAdmin: userData.is_admin || false,
            };

            setToken(token);
            setUser(user);
            localStorage.setItem('user', JSON.stringify(user));

            // Check if there's a pending examId for subscription
            const pendingExamId = localStorage.getItem('pendingExamId');
            if (pendingExamId) {
              localStorage.removeItem('pendingExamId');
              navigate(`/subscription/${pendingExamId}`);
            } else {
              navigate('/dashboard');
            }
          } else {
            console.error('No user data in response:', response.data);
            navigate('/login?error=auth_failed');
          }
        })
        .catch((err) => {
          console.error('Failed to fetch user:', err);
          console.error('Error details:', err.response?.data || err.message);
          // Clear invalid token
          localStorage.removeItem('token');
          navigate('/login?error=auth_failed');
        });
    } else {
      console.error('No token in callback URL');
      navigate('/login?error=no_token');
    }
  }, [searchParams, navigate, setToken, setUser]);

  return (
    <div className="gp-page flex items-center justify-center">
      <div className="text-center gp-animate-in">
        <div className="gp-spinner mb-4" aria-hidden="true" />
        <p className="gp-text-muted text-sm">Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
